// Body load opacity
$(window).on("load",(function(){ 
  setTimeout(function(){     
	$("body").animate({opacity:1},900);  
   // $("#marquee_wrapper svg").css('width', 'auto'); 
  }, 500);
}));

$(document).ready(function() {
  $(".announcement-barrow").prependTo(".header-row");
  $('.announcement_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    vertical:false,
    fade: true,
    autoplay: true,
    speed: 1500
});
});


// Search open
$('.icon-search-link').on('click', function () {
    $('.search-header').slideToggle('fast');
   $('.search-header__input').focus();
});



// Sub navigation menu hover change image
$('.subnav-links li').on('mouseover', function(){
var navimg = $(this).attr('id');  
$('.nav_imgbox ').removeClass('active');      
$('#'+ navimg +'_div').addClass('active');      
});     

// Header add class on scroll
$(window).scroll(function(){
    if ($(this).scrollTop() > 100) {
       $('.header-row').addClass('dark_header');
    } else {
      $('.header-row').removeClass('dark_header');
    }
});

// Mobile menu click
$('.mo_menulink').on('click', function () {
  $('#SiteNav').slideToggle('fast');  
   $('.header-row').toggleClass('header_black');
    $(this).toggleClass('active');  
    $(this).text(function(i, v){
    return v === 'Menu' ? 'Close' : 'Menu'
  })
});

$(document).on('click', '.mobile-content .site-nav--has-dropdown > a', function () {
  if ($(this).closest('li').hasClass('active')) {
    $(this).parents('ul').find('li').removeClass('active');
  } else {
    $(this).parents('ul').find('li').removeClass('active');
    $(this).parent('li').addClass('active');
  }
});

function handleDropdownToggle() {
  if ($(window).width() < 1200) {
    $('ul.site-nav').addClass('mobile-content');
    $('.custom-header-height').addClass('stop-hover');
  } else {
    $('ul.site-nav').removeClass('mobile-content');
    $('.custom-header-height').removeClass('stop-hover');
  }
}

window.addEventListener('resize', function () {
  handleDropdownToggle();
});
handleDropdownToggle();


if($(window).width() < 767){
  // Mobile sub menu open
  $('.site-nav--has-dropdown > a').on('click', function () {
  /*
    $('.site-nav__dropdown').not(this).slideUp('fast');
    $(this).next('.site-nav__dropdown').slideToggle('fast');*/
  


   $('li').find('.site-nav__dropdown').stop().slideUp('fast');
	$(this).closest('li').find('.site-nav__dropdown').stop().slideToggle('fast');  	
  });
} 



 (function() { 
     var REDIRECT_PATH = '/account'; 
   
     var selector = '#RegisterForm, form[action$="/account"][method="post"]', 
         $form = document.querySelectorAll(selector)[0]; 
   
     if ($form) { 
       $redirect = document.createElement('input'); 
       $redirect.setAttribute('name', 'return_to'); 
       $redirect.setAttribute('type', 'hidden'); 
       $redirect.value = REDIRECT_PATH; 
       $form.appendChild($redirect);  
     } 
   })();




   $(function () {
  $('.qty-plus').on('click', function () {
    var input = $(this).siblings('.qty-input');
    input.val(parseInt(input.val()) + 1);
  });

  $('.qty-minus').on('click', function () {
    var input = $(this).siblings('.qty-input');
    var value = parseInt(input.val());

    if (value > 1) {
      input.val(value - 1);
    }
  });



});

/*
$(document).on('click', '.bulk_quantity label', function(e) {
  e.preventDefault();

  $(this).closest('.bulk_quantity')
         .find('ul')
         .slideToggle();
});


$(document).on('click', '.bulk_quantity li a', function(e) {
  e.preventDefault();

  var $item = $(this);
  var $bulk = $item.closest('.bulk_quantity');
  var $form = $bulk.closest('form');

  var qty = $item.attr('data-main-qty');
  var bundleQty = $item.attr('data-bundle-qty');
  var html = $item.attr('data-html');

  // Set quantity for THIS product
  $form.find('.new-quantity').val(qty);

  // Complimentary information
  if (bundleQty) {
    $form.find('.complementary-variant')
         .val(qty + '+' + bundleQty);
  } else {
    $form.find('.complementary-variant').val('');
  }

  // Selected
  $bulk.find('a').removeClass('selected-bundle');
  $item.addClass('selected-bundle');

  // Change label
  $bulk.find('label').html(html);

  // Close dropdown
  $bulk.find('ul').slideUp();
});
*/

